import React from 'react'
import { InputSwitch } from 'primereact/inputswitch'
import clsx from 'clsx'
import './MkSwitch.scss'

export interface MkSwitchProps extends React.HTMLAttributes<HTMLElement>{
  autoFocus?: boolean
  checked: boolean
  className?: string
  disabled?: boolean
  falseValue?: any
  id?: string
  inputId?: string
  name?: string
  onBlur?: (e: any) => void
  onChange?: (e: any) => void
  onFocus?: (e: any) => void
  tabIndex?: number
  trueValue?: any
}

export const MkSwitch: React.FC<MkSwitchProps> = ({
  autoFocus,
  checked,
  className,
  disabled,
  falseValue,
  id,
  inputId,
  name,
  onBlur,
  onChange,
  onFocus,
  tabIndex,
  trueValue,
}) => (
  <InputSwitch
    autoFocus={autoFocus}
    checked={checked}
    className={clsx('mk-switch', { 'mk-switch--disabled': disabled }, className)}
    disabled={disabled}
    falseValue={falseValue}
    id={id}
    inputId={inputId}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    onFocus={onFocus}
    tabIndex={tabIndex}
    trueValue={trueValue}
  />
)
